module.exports = __webpack_public_path__ + "img/waiting.4f183616.png";